import { render, staticRenderFns } from "./payin.vue?vue&type=template&id=66c3f84a&scoped=true"
import script from "./payin.vue?vue&type=script&lang=js"
export * from "./payin.vue?vue&type=script&lang=js"
import style0 from "./payin.vue?vue&type=style&index=0&id=66c3f84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3f84a",
  null
  
)

export default component.exports